// extracted by mini-css-extract-plugin
export default {"container":"CopyRight_container__w5MUZ","icon":"CopyRight_icon__faOdJ","text":"CopyRight_text__7VNec"};